module.exports = __webpack_public_path__ + "img/currencyDetails3.04729c26.png";